import { pubsubService } from '@magview/techpad-upgrade-module';

export default pubsubService;



// WEBPACK FOOTER //
// ./src/scripts/services/pubsub.service.js